import { createFileRoute, Outlet, Link, useRouterState } from "@tanstack/react-router";
import { FileText, Settings, MessageSquare, Home, Users, Image } from "lucide-react";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const nav = [
    { to: "/admin", label: "תוכן", icon: FileText, exact: true },
    { to: "/admin/gallery", label: "גלריה", icon: Image },
    { to: "/admin/messages", label: "הודעות", icon: MessageSquare },
    { to: "/admin/registrations", label: "הרשמות", icon: Users },
    { to: "/admin/settings", label: "הגדרות", icon: Settings },
  ];

  return (
    <div className="min-h-screen flex bg-secondary">
      <aside className="w-64 bg-card border-l border-border flex flex-col">
        <div className="p-6 border-b border-border">
          <Link to="/" className="font-display text-lg font-bold text-primary">תורת חיים</Link>
          <p className="text-xs text-muted-foreground mt-1">פאנל ניהול</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => {
            const active = n.exact ? pathname === n.to : pathname.startsWith(n.to);
            return (
              <Link key={n.to} to={n.to} className={`flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium ${active ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
                <n.icon className="h-4 w-4" /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-border space-y-2">
          <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary px-3 py-2">
            <Home className="h-4 w-4" /> חזרה לאתר
          </Link>
          <a href="https://toratchaim.cloudflareaccess.com/cdn-cgi/access/logout" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-destructive px-3 py-2 w-full">
            התנתק
          </a>
        </div>
      </aside>
      <main className="flex-1 p-8 overflow-auto"><Outlet /></main>
    </div>
  );
}
